import indicadoresApi from '../../api/indicadores'

const state = {
  indicadores: [],
  categorias: [],
  loading: false,
  error: null
}

const getters = {
  getIndicadorById: state => id => {
    return state.indicadores.find(indicador => indicador.id === id)
  },
  getCategoriaById: state => id => {
    return state.categorias.find(categoria => categoria.id === id)
  }
}

const actions = {
  // Acciones para Categorías
  async fetchCategorias({ commit }) {
    commit('setLoading', true)
    try {
      const response = await indicadoresApi.getCategorias()
      commit('setCategorias', response.data)
      return response.data
    } catch (error) {
      commit('setError', error.response?.data?.detail || 'Error al cargar categorías')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  
  async createCategoria({ commit, dispatch }, data) {
    commit('setLoading', true)
    try {
      const response = await indicadoresApi.createCategoria(data)
      await dispatch('fetchCategorias')
      return response.data
    } catch (error) {
      commit('setError', error.response?.data?.detail || 'Error al crear categoría')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  
  async updateCategoria({ commit, dispatch }, { id, data }) {
    commit('setLoading', true)
    try {
      const response = await indicadoresApi.updateCategoria(id, data)
      await dispatch('fetchCategorias')
      return response.data
    } catch (error) {
      commit('setError', error.response?.data?.detail || 'Error al actualizar categoría')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  
  async deleteCategoria({ commit, dispatch }, id) {
    commit('setLoading', true)
    try {
      await indicadoresApi.deleteCategoria(id)
      await dispatch('fetchCategorias')
      return true
    } catch (error) {
      commit('setError', error.response?.data?.detail || 'Error al eliminar categoría')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  
  // Acciones para Indicadores
async fetchIndicadores({ commit }, params = {}) {
  commit('setLoading', true)
  try {
    console.log('Obteniendo indicadores con parámetros:', params)
    console.log('Token actual:', localStorage.getItem('token')?.substring(0, 20) + '...')
    
    const response = await indicadoresApi.getIndicadores(params)
    console.log('Respuesta de indicadores:', response.status, response.statusText)
    
    commit('setIndicadores', response.data)
    return response.data
  } catch (error) {
    console.error('Error completo al cargar indicadores:', error)
    commit('setError', error.response?.data?.detail || 'Error al cargar indicadores')
    throw error
  } finally {
    commit('setLoading', false)
  }
},
  
  async getIndicador({ commit }, id) {
    commit('setLoading', true)
    try {
      const response = await indicadoresApi.getIndicador(id)
      return response.data
    } catch (error) {
      commit('setError', error.response?.data?.detail || 'Error al obtener indicador')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  
  async createIndicador({ commit, dispatch }, data) {
    commit('setLoading', true)
    try {
      const response = await indicadoresApi.createIndicador(data)
      await dispatch('fetchIndicadores')
      return response.data
    } catch (error) {
      commit('setError', error.response?.data?.detail || 'Error al crear indicador')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  
  async updateIndicador({ commit, dispatch }, { id, data }) {
    commit('setLoading', true)
    try {
      const response = await indicadoresApi.updateIndicador(id, data)
      await dispatch('fetchIndicadores')
      return response.data
    } catch (error) {
      commit('setError', error.response?.data?.detail || 'Error al actualizar indicador')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  
  async deleteIndicador({ commit, dispatch }, id) {
    commit('setLoading', true)
    try {
      await indicadoresApi.deleteIndicador(id)
      await dispatch('fetchIndicadores')
      return true
    } catch (error) {
      commit('setError', error.response?.data?.detail || 'Error al eliminar indicador')
      throw error
    } finally {
      commit('setLoading', false)
    }
  }
}

const mutations = {
  setCategorias(state, categorias) {
    state.categorias = categorias
  },
  setIndicadores(state, indicadores) {
    state.indicadores = indicadores
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  setError(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}